<ng-container *ngIf="!(assignmentScheduleStateService.assignmentScheduleDetailsSubject | async)">
    <app-spinner></app-spinner>
</ng-container>

<ng-container
    *ngIf=" (assignmentScheduleStateService.assignmentScheduleDetailsSubject | async) as assignmentScheduleDetails">


    <div class="d-flex flex-column" style="max-height: 100%;">

        <div class="pb-3 d-flex flex-md-row flex-column">
            <div class="d-flex flex-column gap-2">
                <!-- Filter -->
                <app-assignment-schedule-answer-filter-display></app-assignment-schedule-answer-filter-display>

                <!-- Information -->
                <app-assignment-schedule-answer-overview></app-assignment-schedule-answer-overview>
            </div>
        </div>
        <div class="flex-grow-1 overflow-y-auto">
            <div class="d-flex flex-column gap-3">

                <div class="d-flex justify-content-end"
                    *ngIf="getFilteredOptions(assignmentScheduleDetails.options).length">
                    <div class="dropdown cursor-pointer align-items-end" dropdown>
                        <a class="btn btn-sm btn-default dropdown-toggle" dropdownToggle
                            aria-controls="dropdown-animated">
                            <span *ngIf="!assignmentScheduleStateService.isAnyFilterDisplayed">
                                {{'assignmentSchedules.massMutatation.title' | transloco}}
                            </span>
                            <span *ngIf="assignmentScheduleStateService.isAnyFilterDisplayed">
                                {{'assignmentSchedules.massMutatation.titleFiltered' | transloco}}
                            </span>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-end mt-1" *dropdownMenu>
                            <li>
                                <a class="dropdown-item text-success" role="button" (click)="massMutationYes()">
                                    {{'assignmentSchedules.massMutatation.allYes' | transloco}}
                                </a>
                                <a class="dropdown-item  text-warning" role="button" (click)="massMutationMaybe()">
                                    {{'assignmentSchedules.massMutatation.allMaybe' | transloco}}
                                </a>
                                <a class="dropdown-item  text-danger" role="button" (click)="massMutationNo()">
                                    {{'assignmentSchedules.massMutatation.allNo' | transloco}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Options  -->
                <div *ngFor="let option of getFilteredOptions(assignmentScheduleDetails.options)">
                    <app-assignment-schedule-answer-option [option]="option"
                        [assignmentScheduleId]="assignmentScheduleId"></app-assignment-schedule-answer-option>

                    <div>
                        <hr class="light-divider p-0 m-0">
                    </div>
                </div>

                <div class="alert alert-secondary"
                    *ngIf="!getFilteredOptions(assignmentScheduleDetails.options).length">
                    {{'assignmentSchedules.emptyOptions' | transloco}}
                </div>

                <!-- Additional information -->
                <div *ngIf="assignmentScheduleDetails.isCountWishActive">
                    <label for="wishCount">{{'assignmentSchedules.addition.wishCount' | transloco}}</label>
                    <div (click)="openEditAdditionModal()">
                        <input type="number" id="wishCount" rows="5" class="form-control pe-none" disabled
                            [value]="assignmentScheduleDetails.countWish" />
                    </div>
                </div>

                <div>
                    <label for="comment">{{'assignmentSchedules.addition.comment' | transloco}}</label>
                    <div (click)="openEditAdditionModal()">
                        <textarea id="comment" rows="5" class="form-control pe-none"
                            disabled>{{assignmentScheduleDetails.comment}}</textarea>
                    </div>
                </div>

                <div>
                    <button class="btn btn-primary w-100"
                        (click)="openEditAdditionModal()">{{'assignmentSchedules.addition.edit' | transloco}}</button>
                </div>
            </div>
        </div>
    </div>

</ng-container>